<script>
import headNav from "../components/headNav.vue";
import router from "../router";
export default {
  name: "mainHome",
  components:{
    headNav
  },
  created() {

  },
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>

<template>
  <div>
    <head-nav></head-nav>
    <router-view id="views"> </router-view>
  </div>
</template>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/view/mainHome.vue